import React from 'react';
import { KpePastYear } from '../../../_shared/types';
import { Button } from '../../../_shared/components/Button/Button';
import { Card } from '../../../_shared/components/Card/Card';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { ReactComponent as InfoIcon } from '../../../_shared/assets/icons/info-icon.svg';
import { StatusLabel } from '../../../_shared/components/StatusLabel/StatusLabel';
import styles from './KpePastYearCard.module.scss';

interface Props {
  data: KpePastYear;
  onResults: () => void;
  onPlans: () => void;
}

export function KpePastYearCard({ data, onResults, onPlans }: Props) {
  return (
    <Card className={styles.card}>
      <div className={styles.header}>
        <Typography variant="h2">{data.year}</Typography>

        {data.hasPremium ? (
          <StatusLabel variant={'success'}>Премия</StatusLabel>
        ) : (
          <span className={styles.infoIcon}>
            <InfoIcon />
          </span>
        )}
      </div>
      <div className={styles.stats}>
        <div className={styles.statRow}>
          <Typography variant={'text'}>Общая эффективность</Typography>
          <Typography variant={'h3'} className={styles.greyTitle}>
            {data.overallEfficiency}%
          </Typography>
        </div>
        <div className={styles.statRow}>
          <Typography variant={'text'} className={styles.statLabel}>
            Эффективность по показателям
          </Typography>
          <Typography variant={'h3'} className={styles.greyTitle}>
            {data.indicatorsEfficiency.current} из{' '}
            {data.indicatorsEfficiency.total}
          </Typography>
        </div>
      </div>
      <div className={styles.actions}>
        <Button onClick={onResults}>Результаты года</Button>
        <Button variant="secondary" onClick={onPlans}>
          Планы показателей
        </Button>
      </div>
    </Card>
  );
}
